<div [style.border-color]="borderColor"></div>
